export const enum SurveyWidget {
    OPENED = 'opened',
    OPINION = 'opinion',
    CSI = 'csi',
    CLOSED = 'closed',
    COMPLETESCREEN = 'completeScreen',
}

export const enum SurveyOpenedType {
    TEXT = 'text',
    DATE = 'date',
    NUMERIC = 'numeric',
    PHONE = 'phone',
}
